export default __webpack_public_path__ + "static/media/my-request.195ecb38.svg";